import {observer} from "mobx-react";
import styled from "styled-components";
import {useStore} from "@/store";
import {useEffect} from "react";
import {MENU_PATHS_MAP} from "@/components/constants/routes";
import {usePathname, useRouter, useSearchParams} from "next/navigation";

const MenuNavigationWrapPc = observer(() => {
    const {navigationStore} = useStore();
    const pathname = usePathname();
    const router = useRouter();
    const params = useSearchParams();
    const menuId = params.get("menu-id");
    useEffect(() => {
        navigationStore.setClearNavigation("wrap");
    }, [pathname]);

    return(
        <MenuNavigationInnerPc className={"menu"}>
            {
                menuId &&
                navigationStore.setMakeNaviMenu() && navigationStore.setMakeNaviMenu().length > 0 &&
                navigationStore.setMakeNaviMenu().filter(item => item.depth === 1).map((node, idx) => {
                    const children = navigationStore.setMakeNaviMenu().filter(child => child.depth === 2 && child.trail[0].menuId === node.menuId);
                    const isOpen = navigationStore.openIndex === idx;
                    const basePath = MENU_PATHS_MAP.find(map => map.name === node.title)?.path;
                    return (
                        <li
                            key={node.menuId}
                            className={`list ${node.active ? "active" : ""} ${isOpen ? "on" : ""} dem`}
                        >
                            <div
                                className="hover-wrapper"
                                onMouseEnter={() => {
                                    if (node.depth === 1 && node.isParent) {
                                        navigationStore.setOpenIndex(idx);
                                    } else{
                                        navigationStore.setOpenIndex(null);
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (node.depth === 1 && node.isParent) {
                                        const headerEl = document.querySelector(".site-page-header");
                                        const next = e.relatedTarget;
                                        if (!headerEl) return;
                                        if (!next || !(next instanceof Node)) {
                                            navigationStore.setOpenIndex(null);
                                            return;
                                        }
                                        if (headerEl.contains(next)) {
                                            return;
                                        }
                                        navigationStore.setOpenIndex(null);
                                    }
                                }}
                            >
                                <div
                                    className="depth_1"
                                    onClick={() => {
                                        if(node.type === "FOLDER" && node.children && node.children.length > 0){
                                        } else {
                                            if(node.type === "PAGE"){
                                                if(node.component){
                                                    const pagePath  = navigationStore.setFilterPageUrl(node, basePath, menuId);
                                                    router.push(pagePath);
                                                } else {
                                                    alert("준비 중입니다.");
                                                }
                                            }  else {
                                                alert("준비 중입니다.");
                                            }
                                        }
                                    }}
                                >
                                    {node.title}
                                </div>
                                {
                                    children.length > 0 &&
                                    <ul className="depth_2">
                                        {children.map(child => (
                                            <li
                                                key={child.menuId}
                                                className={`child ${child.active ? "active" : ""}`}
                                                onClick={() => {
                                                    let pagePath = "";
                                                    if(child.children && child.children.length > 0){
                                                        const target = navigationStore.findFirstNonFolder(child.children);
                                                        if (!target) {
                                                            alert("준비 중입니다.");
                                                            return;
                                                        }
                                                        pagePath = navigationStore.setFilterPageUrl(target, basePath, menuId);
                                                    } else {
                                                        pagePath = navigationStore.setFilterPageUrl(child, basePath, menuId);
                                                    }
                                                    router.push(pagePath);
                                                    navigationStore.setOpenIndex(null);
                                                }}
                                            >
                                                {child.title}
                                            </li>
                                        ))}
                                    </ul>
                                }
                            </div>

                        </li>
                    );
                })
            }
        </MenuNavigationInnerPc>
    )
});
const MenuNavigationInnerPc = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    gap: 70px;
    &.menu{
        .list {
            height: 100%;
            align-items: center;
            display: flex;

            .hover-wrapper {
                height: 100%;
                align-items: center;
                display: flex;
                position: relative;
            }

            .depth_1 {
                height: 100%;
                align-items: center;
                display: flex;
                cursor: pointer;
                font-weight: 700;
                font-size: 20px;
                letter-spacing: -0.02em;
                transition: color 0.3s ease;

                position: relative;
            }

            &.active .depth_1 {
                color: ${({theme}) => theme.COLORS.SIDE_NAV.active.primary.line} !important;

                &::after {
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 2px;
                    background-color: ${({theme}) => theme.COLORS.SIDE_NAV.active.primary.line};
                    bottom: -1px;
                    left: 0;
                }
            }

            .depth_2 {
                margin: 0;
                position: fixed;
                left: 0;
                top: ${({theme}) => theme.SIZE.HEADER.pc};
                background: #fff;
                width: 100%;
                z-index: 25;
                //justify-content: center;
                display: flex;
                flex-wrap: wrap;
                //column-gap: 70px;
                //row-gap: 30px;
                padding: 30px 310px;
                //gap: 70px;
                opacity: 0;
                transform: translateY(-1px);
                pointer-events: none;
                transition: opacity 0.3s ease, transform 0.3s ease;
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.10), 0 4px 20px 0 rgba(0, 0, 0, 0.06);
                .child {
                    width: 210px;
                    height: 44px;
                    font-weight: 400;
                    font-size: 18px;
                    text-align: center;
                    color: #666666;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    &.active {
                        font-weight: 600;
                        color: #333;
                    }
                }
            }
            &.on .depth_2 {
                opacity: 1;
                transform: translateY(0);
                pointer-events: auto;
            }
        }
    }
`
export default MenuNavigationWrapPc;